import { combineReducers } from 'redux'
import postModal from './postModal'

const postModalReducer = combineReducers({
    postModal,
})

export default postModalReducer
